import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
import { SecuritiesRemoved, SecurityReplacements } from "../Shared";
const GetScenariosRes = z.object({
    blackMonday: z.number().nullable(),
    bondMarketCrisis: z.number().nullable(),
    russianFinancialCrisis: z.number().nullable(),
    dotcomBubble: z.number().nullable(),
    globalFinancialCrisis: z.number().nullable(),
    securityReplacements: SecurityReplacements.nullable(),
    securitiesRemoved: SecuritiesRemoved.nullable(),
});
export const getScenariosV4KeyMaker = (accountGroupId) => [url(accountGroupId)];
export const url = (accountGroupId) => {
    const queryParams = "?scenario=Black%20Monday&scenario=Dotcom%20Bubble&scenario=Russian%20Financial%20Crisis&scenario=Bond%20Market%20Crisis&scenario=Global%20Financial%20Crisis";
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/account-groups/v4/account-groups/${accountGroupId}/scenarios${queryParams}`
        : `https://middleware.uat.farther.com/account-groups/v4/account-groups/${accountGroupId}/scenarios${queryParams}`;
};
export default async function getScenariosV4(accountGroupId, config) {
    const { data } = await axios.get(url(accountGroupId), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            ...("advisorId" in config && { Advisor: config.advisorId }),
            ...("clientId" in config && { Client: config.clientId }),
        },
    });
    const decoded = GetScenariosRes.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "getScenariosV4 returned unexpected data.";
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getScenariosV4.js.map